import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { QuillModule } from 'ngx-quill';
import { MomentModule } from 'ngx-moment';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { RelativeTimeDisplayComponent } from '@qwyk/ui-standalone';

import { components, exportableComponents } from './components';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MomentModule,
        TooltipModule,
        TranslateModule,
        FontAwesomeModule,
        OverlayPanelModule,
        RelativeTimeDisplayComponent,
        QuillModule.forRoot({
            modules: {
                syntax: false,
                toolbar: [
                    [
                        'bold',
                        'italic',
                        'underline',
                        'strike',
                        'blockquote',
                        'link',
                    ],
                    [{ list: 'ordered' }, { list: 'bullet' }],
                    ['clean'],
                ],
            },
        })
    ],
    declarations: components,
    exports: exportableComponents,
})
export class ActivitiesUiModule {}
